import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3615a8b3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrapper p-text-center" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "p-text-center p-pt-5" }, "Forbidden Access 403", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "p-text-center" }, "You are not authorized to access this page", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createVNode(_component_Button, {
      label: "Logout",
      icon: "pi pi-fw pi-power-off",
      class: "p-button-success",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.logOut()))
    })
  ]))
}